import { Layout } from "@/components/layout/Layout";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <Layout
      seo={{
        title: "404 | Page Not Found",
        description: "The page you requested could not be found.",
        canonicalPath: "/404",
        noindex: true,
      }}
    >
      <section className="relative overflow-hidden bg-[#0a101f] px-4 py-16 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(234,179,8,0.12),transparent_28%),radial-gradient(circle_at_80%_20%,rgba(59,130,246,0.08),transparent_24%)]" />
        <div className="relative mx-auto max-w-4xl">
          <div className="rounded-[2rem] border border-white/10 bg-[#10182a]/90 px-6 py-10 text-center text-white shadow-[0_30px_80px_rgba(0,0,0,0.35)] backdrop-blur-xl sm:px-10 sm:py-14">
            <div className="text-[clamp(4.5rem,16vw,8rem)] font-black leading-none tracking-[-0.08em] text-white/10">
              404
            </div>
            <h1 className="mt-3 text-3xl font-black uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">
              Page Not Found
            </h1>
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-7 text-gray-400 sm:text-base">
              The page you are looking for does not exist or may have been moved.
            </p>

            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Link href="/">
                <Button className="h-12 min-w-[200px] rounded-xl bg-primary px-6 font-black text-black hover:bg-primary/90">
                  Back To Homepage <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
              <Button
                type="button"
                variant="outline"
                className="h-12 min-w-[160px] rounded-xl border-white/10 bg-white/5 px-6 font-black text-white hover:bg-white/10"
                onClick={() => (window.history.length > 1 ? window.history.back() : (window.location.href = "/"))}
              >
                <ArrowLeft className="mr-2 h-4 w-4" /> Go Back
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
